import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.handleError = (error, message, detail) => {
  console.warn(message, detail);

  console.error(error);
};

application.warnings = true;
application.debug = process.env.NODE_ENV === "development";
window.Stimulus = application;

export { application };
